export default __webpack_public_path__ + "static/media/rightBottomTrick.7d080754.svg";